<div class="wrapper">
  <div class="results mat-app-background">
    <span class="left">
      <mat-spinner [diameter]="20" *ngIf="lazyLoading"></mat-spinner>
    </span>
    <div class="right">
      <mat-icon *ngIf="scrollLocked" class="primary-color" [matTooltip]="'scroll_locked' | phrase">lock</mat-icon>
      <span *ngIf="countResult && countResult > 0">
        <button class="scrollTo" [disabled]="!activeBazaId || currentIndex < 0" (click)="scrollToWord(currentIndex)">
          {{ currentIndex + 1 }}</button>/ {{ countResult }}<ng-container
          *ngIf="unfilteredCountResult && unfilteredCountResult != countResult"> / {{ unfilteredCountResult }}
        </ng-container>
      </span>
    </div>
  </div>
  <div class="notFoundInList mat-app-background" *ngIf="notFoundInList && !lazyLoading" [@notFoundWindow]>
    <span>{{ 'leftnav_notfound' | phrase }}</span>
  </div>

  <cdk-virtual-scroll-viewport itemSize="35" class="list">
    <ng-container *ngIf="!loading">
      <app-word-list-item class="item" *cdkVirtualFor="let baza of bazaList; let i = index; trackBy: trackById"
        (click)="tryActivateBaza(baza.id, false)" matRipple [class.active]="activeBazaId == baza.id"
        [class.highlighted]="foundWordIndex == i" [attr.id]="'w-' + baza.id" [attr.tabindex]="i + 1"
        (keypress)="keyPress($event, baza.id)" (keydown)="keyDown($event)" [baza]="baza" [index]="i + 1"
        [userId]="userId"></app-word-list-item>
    </ng-container>
  </cdk-virtual-scroll-viewport>

  <ng-container *ngIf="loading; else notFound">
    <div class="loading">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
  </ng-container>
  <ng-template #notFound>
    <span *ngIf="bazaList && bazaList.length == 0 && !lazyLoading" class="notFound">{{ 'leftnav_notfound' | phrase }}
    </span>
  </ng-template>
</div>

<ng-template #template>
  <div class="comments">
    <div class="items" *ngIf="komentetGroup && komentetGroup.length > 0; else loading">
      <div class="group" *ngFor="let komentiGroup of komentetGroup">
        <div class="item" [class.self]="userId == komenti.regjistruarOperatoriId"
          *ngFor="let komenti of komentiGroup.komentet; let i = index">
          <span class="operatori">{{ komenti.regjistruarOperatori }}</span>
          <div class="pershkrimi-wrap">
            <span
              class="pershkrimi"
              matTooltipShowDelay="500"
              [matTooltip]="(komenti.dataRegjistrimit | date: 'dd.MM.yyyy - H:mm')!"
              [matTooltipPosition]="userId == komenti.regjistruarOperatoriId ? 'before' : 'after'"
              >{{ komenti.pershkrimi }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <ng-template #loading>
      <mat-spinner [diameter]="20"></mat-spinner>
    </ng-template>
  </div>
</ng-template>
